import { THEMES, Theme } from './BlogHeader.consts';

export const isValidTheme = (themeName?: string | null): themeName is Theme => {
  if (!themeName) return false;
  return THEMES.includes(themeName as Theme);
};
